import { createFileRoute } from '@tanstack/react-router';

import { IDNProfileModal } from '~/components/modals/idn/IDNProfileModal';
import { USER_ROLES } from '~/features/auth/roles';
import { Route as CustomerAdminIDNsRoute } from '~/routes/customer-administration/idns';
import { protectedRoute } from '~/utils/routesAuthorization';

const TEST_ID = 'idn-details';

export const Route = createFileRoute('/customer-administration/idns/$idnId')({
  component: IDNProfileRoute,
  params: {
    parse: (params) => ({ idnId: params.idnId }),
  },
  beforeLoad: () => {
    protectedRoute({
      roles: [USER_ROLES.AdminAbbott, USER_ROLES.AbbottUser],
    });
  },
});

function IDNProfileRoute() {
  const { idnId } = Route.useParams();

  return (
    <IDNProfileModal
      testID={TEST_ID}
      onCloseRedirectPath={CustomerAdminIDNsRoute.fullPath}
      idnId={idnId}
    />
  );
}
